import { makeMed4, makeReg4 } from './textStyles';
const getRoundedStyles = (tokens) => ({
    table: {
        background: tokens.CanvasTableHeader,
        borderRadius: '8px',
        '-webkit-tap-highlight-color': 'transparent',
    },
    thead: {
        background: tokens.CanvasTableHeader,
        borderBottomColor: tokens.BorderMedium600,
        borderBottomWidth: tokens.BorderWidth01,
    },
    tr: makeReg4(tokens, {
        borderBottomColor: tokens.BorderLight200,
        borderBottomWidth: tokens.BorderWidth01,
        color: tokens.TextMedium600,
        background: tokens.CanvasTableRowLight,
    }),
    td: {
        py: 1,
        px: 3,
    },
    th: makeMed4(tokens, {
        textTransform: 'none',
        color: tokens.TextBlack800,
        background: tokens.CanvasTableHeader,
        letterSpacing: 'normal',
        py: 5,
        px: 3,
    }),
});
const tableStyles = (tokens) => {
    const roundedStyles = getRoundedStyles(tokens);
    return {
        variants: {
            rounded: roundedStyles,
            searchResults: {
                table: {
                    background: tokens.Layer01,
                },
                td: {
                    py: tokens.Spacing04,
                    px: tokens.Spacing05,
                    textColor: tokens.TextDark800,
                    fontSize: tokens.TextBodyReg4FontSize,
                    _hover: {
                        background: tokens.Layer02,
                    },
                },
            },
        },
    };
};
export default tableStyles;
